import styled from 'styled-components'

export const Content = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 16px 26px;
`

export const Title = styled.span`
  font-size: 20px;
  font-weight: 600;
`

export const SubTitle = styled.div`
  font-size: 18px;
  font-weight: 500;
  line-height: 28px;
  color: #282828;
`

export const Label = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
`

export const Input = styled.input`
  background: #f9f9f9;
  border: 1px solid #cecece;
  box-sizing: border-box;
  border-radius: 5px;
  width: 100%;
  height: 40px;
  margin-top: 12px;
  text-indent: 16px;

  &:focus {
    border: 1px solid ${({ theme }) => theme.colors.primary};
    outline: none;
  }

  &::placeholder {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;
    display: flex;
    align-items: center;
    color: #a5a5a5;
  }
`

export const GitButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  & > .button {
    flex: 1;
  }
`
